import gql from 'graphql-tag';

export const GENERATE_LOGIN_TOKEN = gql`
  mutation GenerateLoginTokenForUserForApp {
    result: generateLoginTokenForUser {
      token
    }
  }
`;
